import styled from "styled-components";

export const RecurringPaymentToggled = styled.div`
  border-radius: 4px;
  background-color: #cdf4de;
  padding: 15px 20px;
`;



// WEBPACK FOOTER //
// ./src/components/forms/loan-payment-ach/styles.js